import BaseAPI from '../base'

function login(email, password) {
    return BaseAPI.post('auth/login/admin', {
        email,
        password
    });
}

function loginQuick(code) {
    return BaseAPI.post('auth/login/admin/quick', {
        code
    });
}

function me() {
    return BaseAPI.get('auth/me/dashboard');
}

function logout() {
    return BaseAPI.post('auth/logout');
}

function changePassword(oldPass, newPass) {
    return BaseAPI.post(`auth/changePassword`, {
        oldPass,
        newPass
    });
}

function setLanguage(l) {
    return BaseAPI.post(`auth/setLanguage/${l}`)
}

function setDashboardLanguage(l) {
  return BaseAPI.post(`auth/setDashboardLanguage/${l}`);
}


function changeEmail(new_email, password) {
    return BaseAPI.post(`auth/changeEmail`, {
        new_email,
        password
    });
}


function confirmEmailChange(key) {
    return BaseAPI.post(`auth/confirmChangeEmail/${key}`);
}

function deleteAccount(password) {
    return BaseAPI.post(`auth/destroy_account`, {
        password
    });
}

function changeTwoFactorAuth(enabled, phone) {
    return BaseAPI.post(`auth/2fa/change`, {
        enabled,
        phone
    });
}

function confirmTwoFactorAuthChange(token, code) {
    return BaseAPI.post(`auth/2fa/confirm_change`, {
        token,
        code
    });
}

function confirmTwoFactorLogin(token, code) {
    return BaseAPI.post(`auth/login/admin/2fa`, {
        token,
        code
    });
}

function updateProfile(data) {
    return BaseAPI.post(`auth/update_profile`, data);
}

function switchSession(sid) {
    return BaseAPI.post(`auth/switch/admin`, {
        sid
    })
}

function forgotPassword(email) {
    return BaseAPI.post(`/auth/forgot_password`, {
        email
    });
}

function resetPassword(token, password) {
    return BaseAPI.post(`/auth/forgot_password/${token}`, {
        password
    });
}

export default {
  login,
  me,
  logout,
  changePassword,
  setLanguage,
  changeEmail,
  confirmEmailChange,
  deleteAccount,
  changeTwoFactorAuth,
  confirmTwoFactorAuthChange,
  confirmTwoFactorLogin,
  updateProfile,
  switchSession,
  forgotPassword,
  resetPassword,
  loginQuick,
  setDashboardLanguage,
};